<p><a class="btn btn-primary btn-sm" (click)="createOffer()">Angebot erstellen</a></p>

<clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'offer_id'" [clrDgSortOrder]="descSort">Angebot</clr-dg-column>
    <clr-dg-column>Anfrage-/Bestellnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Kunde/Betreff</clr-dg-column>
    <clr-dg-column [clrDgField]="'offer_date'">Datum</clr-dg-column>
    <clr-dg-column [clrDgField]="'budget'">Summe (netto)</clr-dg-column>
    <clr-dg-column>Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Offers!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let offer of offers" [routerLink]="['/offer/details', offer.project_id, offer.offer_id]">
        <clr-dg-cell>{{ offer.project_id }}.0003.{{ offer.offer_id}}</clr-dg-cell>
        <clr-dg-cell>{{ offer.request_id }}<br />{{ offer.order_id }}</clr-dg-cell>
        <clr-dg-cell><b>{{ offer.company_name }}</b><br />{{ offer.name_project }}</clr-dg-cell>
        <clr-dg-cell>{{ offer.offer_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
        <clr-dg-cell class="currency"><b>{{ offer.budget | currency: 'EUR':'code':'1.2-2':'de'  }}</b></clr-dg-cell>
        <clr-dg-cell [className]="findButtonClass(offer.status)" role="alert">
            <div class="alert-items">
                <div class="alert-item static">
                    <span class="alert-text">{{ getCellStatus(offer.status).statusDisplay}}</span>
                </div>
            </div>
        </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="50">
            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Angebote pro Seite</clr-dg-page-size>
            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
            von  {{ offers.length }} Angebot(e)
        </clr-dg-pagination>
    </clr-dg-footer>
</clr-datagrid>
